if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    document.addEventListener('DOMContentLoaded', function() {
        const toggleButtonReserve = document.getElementById("btn-reserve");
        const formContainer = document.querySelector('.form-container');
        const textReserve = document.getElementById("btn-reserve");
        if(toggleButtonReserve){
            toggleButtonReserve.addEventListener("click", function() {
                if (formContainer.classList.contains("active")) {
                    textReserve.textContent = "start planning";
                    formContainer.classList.remove("active");
                    toggleButtonReserve.classList.remove("active");
                } else {
                    textReserve.textContent = "close";
                    formContainer.classList.add("active");
                    toggleButtonReserve.classList.add("active");
                }
            });
        }

        const mobileButton = document.getElementById('menu-btn');
        const mobileNav = document.querySelector('.mobile-nav');
        if (mobileButton) {
            mobileButton.addEventListener('click', function(){
                if (mobileNav.classList.contains("active")) {
                    mobileButton.textContent = "menu";
                    mobileNav.classList.remove("active");
                    mobileButton.classList.remove("active");
                } else {
                    mobileButton.textContent = "close";
                    mobileNav.classList.add("active");
                    mobileButton.classList.add("active");
                }
            });
        }

        let scrollButtons = document.querySelectorAll('.js-scroll');

        if(scrollButtons.length > 0){
            scrollButtons.forEach((button)=>{
                button.addEventListener('click', (e)=>{
                    e.preventDefault();
                    let data = button.getAttribute('href').split('#')[1];
                    let target = document.getElementById(data);
                    let headerHeight = document.querySelector('header').offsetHeight;
    
                    window.scrollTo({
                        top: target.offsetTop + 200,
                        behavior: 'smooth'
                    });
                });
            });
        }
        
        // for input label in mobile
        if (window.innerWidth <= 767) {
            let dateInputs = document.querySelectorAll('input[type="date"], input[type="time"]');
            dateInputs.forEach(function(input) {
                input.addEventListener('input', function() {
                    if (input.value.length > 0) {
                        input.classList.add('full');
                    } else {
                        input.classList.remove('full');
                    }
                });
            });
        }

    });
    
    // $('.sym-slides.slider').slick("refresh");
    // tpl gallery 
    if (typeof customLightbox !== 'undefined') {
		customLightbox.fullScreen = true;
	}

})();